import useAppNavigation from '@/hooks/useAppNavigation';
import { isEmpty, isNil } from 'lodash-es';
import type React from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { ROUTES } from '../../../constants/Constants';
import usePrelaunch from '../../../hooks/usePrelaunch';
import useUser from '../../../hooks/useUser';
import PartnerRoute from '../../../route/PartnerRoute/PartnerRoute';
import type { AppSsrFetchedDataType } from '../../../server/AppSsr';
import DashboardPage from '../Dashboard/DashboardPage';
import Prelaunch from '../Prelaunch';
import Welcome from '../Welcome';

interface HomeProps {
  ssrFetchedData: AppSsrFetchedDataType;
}

const Home: React.FC<HomeProps> = ({ ssrFetchedData }) => {
  const { isPrelaunch } = usePrelaunch();
  const { currentUser, isPartner } = useUser();
  const location = useLocation();
  const { isSameRoute } = useAppNavigation();
  const { i18n } = useTranslation();

  const home = useMemo(() => {
    if (!isNil(location)) {
      const validPath =
        isSameRoute(location.pathname, ROUTES.DASHBOARD_ROUTE) ||
        isSameRoute(location.pathname, ROUTES.HOME_ROUTE) ||
        isEmpty(location) ||
        (!isNil(i18n?.language) && location.pathname === `/${i18n.language}/`);

      if (validPath) {
        if (isPartner) {
          return (
            <PartnerRoute>
              <DashboardPage ssrFetchedData={ssrFetchedData} />
            </PartnerRoute>
          );
        }
      }

      if (!isPrelaunch || !isNil(currentUser)) {
        return <Welcome ssrFetchedData={ssrFetchedData} />;
      }

      return <Prelaunch ssrFetchedData={ssrFetchedData} />;
    }
  }, [
    ssrFetchedData,
    isPartner,
    location,
    isPrelaunch,
    currentUser,
    isSameRoute,
    i18n.language,
  ]);

  return home;
};

export default Home;
